import { Component } from '@angular/core';
import { Overlay } from "./../commonMap/overlay";

@Component({
    moduleId: module.id,
    selector: 's146g-s146m01',
    templateUrl: './s146g-s146m01.component.html'
})
export class S146gS146m01Component extends Overlay {
    scrndt: any = {};
    scrntm: any = {};
    trnnbr: any = {'value': '____'};
    legnbr: any = {'value': '__'};
    origin: any = {'value': '___'};
    destin: any = {'value': '___'};
    pctint: any = {'value': '____'};
    pctdec: any = {'value': '__'};
    riders1: any = {'value': '____'};
    riders2: any = {'value': '____'};
    msgln: any = {};

    public FIELDS: string[] = ['scrndt', 'scrntm', 'trnnbr', 'legnbr', 'origin', 'destin', 'pctint', 'pctdec', 'riders1', 'riders2', 'msgln'];
    public LINES: number[] = [1, 2, 3, 4, 6, 7, 9, 11, 12, 14, 16, 17, 18, 19, 22, 24];

    ngAfterViewInit(): void {
    }
}
